import { Card, Divider, Modal, Typography } from 'antd';
import { requestform } from '../../../messages';
import React, { useState } from 'react';
import { GetCustomerRequestHistoryQuery } from '../../../hooks/request-form';
import dayjs from 'dayjs';
import CustomerHistoryRequest from '../../customer-history-request-ticket/CustomerHistoryRequest';

interface HistoryCreatingTicket {
  customerCode: string;
}

const ModalHistoryCreatingTicket: React.FC<HistoryCreatingTicket> = ({ customerCode }) => {
  const { customerRequestHistory } = GetCustomerRequestHistoryQuery(customerCode);

  const [isOpenCustomerHistoryRequest, setIsOpenCustomerHistoryRequest] = useState(false);
  const openHistoryRequestModal = () => setIsOpenCustomerHistoryRequest(true);
  const closeHistoryRequestModal = () => setIsOpenCustomerHistoryRequest(false);

  const [currentTicketId, setCurrentTicketId] = useState(0);
  const [currentStatus, setCurrentStatus] = useState(customerRequestHistory[0]?.status?.code || '');

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.historyCreatingTicket}
        </Typography.Text>
      }
      className='h-[80vh] bg-[#FFFFFF] text-center'
    >
      <div className='h-full w-full overflow-y-auto'>
        {customerRequestHistory.map((item, index) => (
          <div key={index + 1}>
            <div className='w-full text-left'>
              <button
                onClick={() => {
                  openHistoryRequestModal();
                  setCurrentTicketId(item.ticketId);
                  setCurrentStatus(item.status.code);
                }}
                className='w-full py-4 text-left hover:bg-[#F5F5F7]'
              >
                <div className='flex justify-between gap-3'>
                  <div className='w-[75%]'>
                    <Typography.Text className='text-[16px]/[20px] text-[#181818]'>
                      {item?.serviceType?.name}
                    </Typography.Text>
                  </div>
                  <div className='w-[25%]'>
                    <Typography.Text className='text-[16px]/[20px] text-[#181818]'>
                      Id: {item?.ticketId}
                    </Typography.Text>
                  </div>
                </div>
                <div>
                  <Typography.Text className='text-[14px]/[18px] text-[#6C737E]'>
                    {dayjs(item?.updatedAt).format('DD/MM/YYYY, HH:mm')}
                  </Typography.Text>
                </div>
              </button>
            </div>
            <Divider className='my-1' />
          </div>
        ))}

        <Modal
          centered
          className='ant-modal-body-p-none w-fit rounded-xl bg-[#F5F4F6]'
          open={isOpenCustomerHistoryRequest}
          onCancel={closeHistoryRequestModal}
          footer={null}
          destroyOnClose
        >
          <CustomerHistoryRequest status={currentStatus} ticketId={currentTicketId} />
        </Modal>
      </div>
    </Card>
  );
};

export default ModalHistoryCreatingTicket;
